module.exports = __webpack_public_path__ + "img/professional.f1305b6c.svg";